module.exports = __webpack_public_path__ + "static/img/displays.d0353134.png";